import { useEffect, useRef } from 'react'

interface ConfirmDialogProps {
  open: boolean
  title: string
  message?: string
  confirmText?: string
  cancelText?: string
  danger?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmDialog({ open, title, message, confirmText = 'OK', cancelText = 'Cancel', danger, onConfirm, onCancel }: ConfirmDialogProps) {
  const okRef = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    if (open) okRef.current?.focus()
  }, [open])
  if (!open) return null
  return (
    <div id="modal-confirm" className="modal-overlay show active" onClick={onCancel} style={{ display: 'flex' }}>
      <div className="modal" style={{ maxWidth: 380 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" id="confirm-title">{title}</div>
        <div className="modal-body">
          {message && <p id="confirm-message" style={{ color: 'var(--text-secondary)', fontSize: '0.9375rem' }}>{message}</p>}
        </div>
        <div className="modal-footer">
          <button id="confirm-cancel" type="button" className="btn btn-ghost" onClick={onCancel}>{cancelText}</button>
          <button id="confirm-ok" ref={okRef} type="button" className={danger ? 'btn btn-danger' : 'btn btn-primary'} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  )
}
